export const SECTION_TITLE = 'MỘT VÀI HÌNH ẢNH VỀ CHỦ TỊCH HỒ CHÍ MINH'

export const SLIDERS = [
    {
        imgUrl: '://res.cloudinary.com/yitute/image/upload/v1685258433/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_uq0exu.webp',
        title: '',
        content: ''
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685258082/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_uq0exu.webp',
        title: '',
        content: ''
    },
]

export const ITEMS = [ 
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685259549/2022-2023/HCM/anh/H%C3%ACnh_16_th%E1%BA%BB_%C4%91%E1%BA%A3ng_vi%C3%AAn_q2umtk.webp',
        title: 'Thẻ đảng viên Đảng Cộng sản Pháp của đồng chí Nguyễn Ái Quốc.',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685261366/2022-2023/HCM/anh/H%C3%ACnh_15_ijwpke.webp',
        title: 'Lần đầu tiên lấy tên Nguyễn Ái Quốc, thay mặt Hội Những người Việt Nam yêu nước tại Pháp. Người viết và gửi yêu sách 8 điểm của nhân dân Việt Nam tới Hội nghị Versailles ngày 18/6/1919, đòi quyền tự do cho dân tộc Việt Nam. Đây là tiếng súng báo hiệu sự bùng nổ cách mạng Đông Dương.',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685263319/2022-2023/HCM/anh/H%C3%ACnh_17_NAQ_t%E1%BA%A1i_DH_Tours_ycjhpx.webp',
        title: 'Nguyễn Ái Quốc, đại biểu Đông Dương, tham dự Đại hội toàn quốc Đảng Xã hội Pháp ở thành phố Tours (nước Pháp), tháng 12/1920. Tại Đại hội, Nguyễn Ái Quốc tán thành việc gia nhập Quốc tế III (Quốc tế Cộng sản), là thành viên sáng lập Đảng Cộng sản Pháp, trở thành người cộng sản đầu tiên của dân tộc Việt Nam.',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685264892/2022-2023/HCM/anh/H%C3%ACnh_24_L%C3%A1n_Khu%E1%BB%95i_N%E1%BA%ADm_P%C3%A1c_B%C3%B3_bnspjt.webp',
        title: 'Lán Khuổi Nậm, Pác Bó, Cao Bằng, nơi Chủ tịch Hồ Chí Minh chủ trì Hội nghị Trung ương 8 của Đảng Cộng sản Đông Dương (tháng 5/1941) họp quyết định thành lập Việt Nam độc lập đồng minh (Mặt trận Việt Minh) lãnh đạo nhân dân cả nước thực hiện nhiệm vụ giải phóng dân tộc.',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685264973/2022-2023/HCM/anh/H%C3%ACnh_26a_Ngay_2_thang_9_doebt8.webp',
        title: 'Ngày 02/9/1945, tại Hà Nội, Chủ tịch Hồ Chí Minh đọc Tuyên ngôn độc lập, khai sinh nước Việt Nam Dân chủ Cộng hòa, mở ra kỷ nguyên mới của lịch sử dân tộc. Câu hỏi của Người “Tôi nói đồng bào nghe rõ không?” từ đây khắc sâu trong trái tim mỗi người dân Việt Nam.',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685265148/2022-2023/HCM/anh/H%C3%ACnh_38_%C4%90o%C3%A0n_%C4%91%E1%BA%A1i_bi%E1%BB%83u_thanh_ni%C3%AAn_Nam_b%E1%BB%99_kgsndq.webp',
        title: 'Năm 1949, Đoàn đại biểu thanh niên Nam Bộ ra thăm miền Bắc đã tới quây quần bên vị lãnh tụ kính yêu của dân tộc. Miền Nam là nơi đầu tiên trong cả nước phải chống Pháp tái chiếm (từ 23/9/1945).',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685265209/2022-2023/HCM/anh/H%C3%ACnh_46_B%C3%A1c_%C4%91i_m%E1%BA%B7t_tr%E1%BA%ADn_kybqbl.webp',
        title: 'Chủ tịch Hồ Chí Minh - người sáng lập và lãnh đạo quân đội ta - theo dõi mặt trận suốt thời gian chiến dịch Biên giới. Nơi ở của Người chuyển theo các trận đánh, có khi chỉ là túp lều cỏ dựng tạm vài hôm.',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685265282/2022-2023/HCM/anh/H%C3%ACnh_51_i9r1do.webp',
        title: 'Nhận định về triển vọng cuộc kháng chiến chống thực dân Pháp, Chủ tịch Hồ Chí Minh viết trong báo cáo: “Nay tuy châu chấu đá voi, Nhưng mai voi sẽ bị lòi ruột ra”.',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685265347/2022-2023/HCM/anh/H%C3%ACnh_59_m0eaah.webp',
        title: 'Sau 58 ngày đêm chiến đấu, ngày 07/5/1954, quân ta toàn thắng ở Điện Biên Phủ. Lá cờ quyết chiến quyết thắng của Hồ Chủ tịch tặng các đơn vị tham gia chiến dịch Điện Biên Phủ tung bay phấp phới trên nắp hầm chỉ huy của địch.',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685265444/2022-2023/HCM/anh/H%C3%ACnh_67_t0v27x.webp',
        title: 'Ngày 05/9/1960, Đảng Lao động Việt Nam họp Đại hội đại biểu toàn quốc lần thứ 3. Trong diễn văn khai mạc, Người nêu rõ: “... Đại hội lần này là đại hội xây dựng chủ nghĩa xã hội ở miền Bắc và đấu tranh hòa bình thống nhất nước nhà”.',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685265546/2022-2023/HCM/anh/H%C3%ACnh_70_bf1gvp.webp',
        title: 'Bác bắt nhịp bài “Kết đoàn” trong buổi hòa nhạc mừng Đại hội Đảng năm 1960.',
    },
]